import { useOptimisedImages } from '@navi-toolbox/hooks';
import { LinkButton } from 'fronton-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BrandWord } from './brand-word';
import { brandLinkItem, otherProductsImageWrapper, image } from '../styles';
import { ImagePlaceholder } from 'common/components/image-placeholder/image-placeholder';
import { ImageFallback } from 'common/components';

type BrandLinkProps = {
  label: string;
  link: string;
  type: 'brand' | 'category';
  imageUrl?: string;
};

export const BrandLink: FC<BrandLinkProps> = ({ label, link, type, imageUrl }) => {
  const { t } = useTranslation();

  const imageSize = {
    h: '48',
    w: '48',
  };

  const optimizedImage = useOptimisedImages({
    src: imageUrl,
    sizes: {
      restImage: imageSize,
    },
  });

  const typeLabel =
    type === 'brand'
      ? t('other-products.brand', { brand: label })
      : t('other-products.category', { category: label.toLowerCase() });

  const shouldRenderBrandWord = type === 'brand' && !imageUrl;
  const shouldRenderFallback = type === 'category' && !imageUrl;
  const shouldRenderImage = !shouldRenderBrandWord && !shouldRenderFallback;

  return (
    <LinkButton className={brandLinkItem} href={link} aria-label={typeLabel}>
      <div className={otherProductsImageWrapper}>
        {shouldRenderBrandWord && <BrandWord brandName={label} />}
        {shouldRenderFallback && <ImageFallback width={Number(imageSize.w)} height={Number(imageSize.h)} />}

        {shouldRenderImage && (
          <ImagePlaceholder
            className={image}
            src={optimizedImage.restImage?.x || ''}
            srcSet={`${optimizedImage.restImage?.xx} 2x, ${optimizedImage.restImage?.x} 1x`}
            alt={label}
            title={label}
            width={imageSize.w}
            height={imageSize.h}
            fallback={<ImageFallback width={Number(imageSize.w)} height={Number(imageSize.h)} />}
            loading="lazy"
          />
        )}
      </div>
      <span>{typeLabel}</span>
    </LinkButton>
  );
};
